import React from 'react'
import Hero from '../Components/Sales/Hero'
import SectionTwo from '../Components/Sales/SectionTwo'
import SectionThree from '../Components/Sales/SectionThree'
import SectionFour from '../Components/Sales/SectionFour'
import SectionFive from '../Components/Sales/SectionFive'
import SectionSix from '../Components/Sales/SectionSix'
import SectionSeven from '../Components/Sales/SectionSeven'
import SectionEight from '../Components/Sales/SectionEight'
import SectionNine from '../Components/Sales/SectionNine'
import SectionTen from '../Components/Sales/SectionTen'
import SectionEleven from '../Components/Sales/SectionEleven'
import SectionTwelve from '../Components/Sales/SectionTwelve'
import SectionThirteen from '../Components/Sales/SectionThirteen'
import {SectionFourteen} from '../Components/Sales/SectionFourteen'
import SectionFifteen from '../Components/Sales/SectionFifteen'
import SectionSixteen from '../Components/Sales/SectionSixteen'
import SectionSeventeen from '../Components/Sales/SectionSeventeen'
import SectionEighteen from '../Components/Sales/SectionEighteen'
const Sales = () => {
  return (
    <div>
        <Hero/>
        <SectionTwo/>
        <SectionThree/>
        <SectionFour/>
        <SectionFive/>
        <SectionSix/>
        <SectionSeven/>
        <SectionEight/>
        <SectionNine/>
        <SectionTen/>
        <SectionEleven/>
        <SectionTwelve/>
        <SectionThirteen/>
        <SectionFourteen/>
        <SectionFifteen/>
        <SectionSixteen/>
        <SectionSeventeen/>
        <SectionEighteen/>
    </div>
  )
}

export default Sales